<template>
  <v-flex md12>
    <kendo-grid
      height="calc(100vh - 145px)"
      :dataSource="dataSource"
      :editable="{mode: 'inline'}"
      :toolbar="editable && isMasterClient ? ['create'] : []"
      ref="grid"
      :filterable="true"
      :sortable="true"
      :pageable-always-visible="true"
      :data-source="this.dataSource"
      :columns="columns"
    >
    </kendo-grid>
  </v-flex>
</template>

<script>
import $ from '../../helpers/jquery-bridge'
import {getDataItem} from '@/helpers/kendo-helpers'
import {enableExportExcel} from '@/helpers/export-helper'
import {readOnlyEditor, jsonDropDownEditor, numericEditor} from '@/helpers/kendo-editors'
import {mapGetters} from 'vuex'

export default {
  mounted() {
    const grid = this.$refs.grid.kendoWidget()
    enableExportExcel(grid, '/api/config/Currency/exportToExcel')
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({role: 'authentication/currentRole'}),
    isMasterClient() {
      return this.clientId == 0
    },
    columns() {
      return [
        {
          editable: this.editable && this.isMasterClient,
          command: [{name: 'edit'}],
          width: 60,
        },
        {
          field: 'marketName',
          title: 'Market',
          width: 182,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align:left'},
          editor: jsonDropDownEditor(
            'marketId',
            'marketName',
            '/api/config/currency/getMarkets',
            {
              change: e => {
                const dataItem = e.sender.dataItem()
                let rowItem = getDataItem(e.sender.element)
                if (dataItem.marketId == 1) {
                  rowItem.set('unitId', 3)
                }
              },
            },
            false,
          ),
        },
        {
          field: 'ccy',
          title: 'Com.Ccy',
          width: 100,
          editor: this.ccyEditor,
          attributes: {style: 'text-align:left'},
        },
        {
          field: 'description',
          title: 'Name',
          width: 182,
        },
        {
          field: 'unitName',
          title: 'Unit',
          width: 100,
          attributes: {style: 'text-align: left;'},
          editor: function(container, options) {
            const marketId = options.model.marketId
            if (marketId != 1) {
              return jsonDropDownEditor('unitId', 'unitName', '/api/config/currency/getUnit').call(
                this,
                container,
                options,
              )
            } else {
              return readOnlyEditor.call(this, container, options)
            }
          },
        },
        {
          field: 'secondUnit',
          title: 'Second Unit',
          editor: function(container, options) {
            const marketId = options.model.marketId
            if (marketId != 1) {
              return jsonDropDownEditor(
                'secondUnitId',
                'secondUnit',
                '/api/config/currency/getSecondUnit',
              ).call(this, container, options)
            } else {
              return readOnlyEditor.call(this, container, options)
            }
          },
          width: 150,
        },
        {
          field: 'ratio',
          title: 'Ratio',
          editor: numericEditor(
            {
              decimals: 4,
              format: '{0:n4}',
              spinners: false,
            },
            true,
          ),
          width: 110,
        },
        {
          editable: this.editable && this.isMasterClient,
          command: [{name: 'destroy', visible: dataItem => dataItem.canDelete}],
          width: 60,
        },
        {},
      ].filter(c => c.editable !== false)
    },
    editable() {
      return this.role != 'Guest'
    },
  },
  methods: {
    ccyEditor(container, options) {
      var isNew = options.model.id === ''
      if (isNew) {
        var input = $(
          '<input class="k-textbox" name="' +
            options.field +
            '" required="required" maxlength="3" />',
        )
        input.appendTo(container)
        return
      }
      return readOnlyEditor.call(this, container, options)
    },
  },
  data() {
    return {
      dataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 30,
        transport: {
          create: {
            type: 'POST',
            url: '/api/config/currency',
            data: () => ({clientId: this.clientId}),
            dataType: 'json',
          },
          read: {
            type: 'GET',
            url: '/api/config/currency',
            data: () => ({clientId: this.clientId}),
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/config/currency',
            data: () => ({clientId: this.clientId}),
            dataType: 'json',
          },
          destroy: {
            type: 'DELETE',
            url: '/api/config/currency',
            dataType: 'json',
          },
        },
        requestEnd: e => {
          if (e.type == 'update' || e.type == 'create') {
            this.$refs.grid.kendoWidget().dataSource.read()
          }
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'ccy',
            fields: {
              ccy: {type: 'string', validation: {required: true}},
              description: {type: 'string', validation: {required: true}},
              marketId: {type: 'number', validation: {required: true}},
              marketName: {type: 'string', validation: {required: true}},
              unitId: {type: 'number', validation: {required: true}},
              secondUnitId: {type: 'number', validation: {required: true}},
              unitName: {type: 'string', validation: {required: true}},
              secondUnit: {type: 'string'},
              ratio: {type: 'number', validation: {required: true}},
              canDelete: {type: 'bool', defaultValue: true, editable: false},
            },
          },
        },
      }),
    }
  },
}
</script>

<style scoped></style>
